import { CnPage } from '@/components/cn-page';

export default CnPage;
